<template>
  <div class="cpm-wrapper">
    <SearchNav />
    <div class="shop-none-goods__title">购物车</div>
    <div class="shop-none-goods__content">
      <div class="none-sec">
        <img class="none-img" :src="require('@/assets/img/cart-none.png')" />
        <p class="none-txt">购物车为空</p>
      </div>
    </div>
    <div v-if="goodsList.length" class="shop-none-goods__intrerest">
      <div class="goods-wrapper">
        <div class="goods-title">
          <p class="main-title">你可能感兴趣</p>
          <p @click="goGoodsList" class="seemore">查看更多</p>
        </div>
        <div class="goods-list">
          <SlideWrap :onceSlideWidth="1175" v-if="goodsList.length">
            <div class="goods-item" v-for="(goods, index) in goodsList" :key="index">
              <div @click="handlerItemDetailClick(goods)" class="img-wrapper">
                <img
                  class="img"
                  v-if="goods.itemImg"
                  :src="goods.itemImg + '?x-oss-process=image/resize,w_240/quality,q_90'"
                />
                <img class="img" v-else :src="require('@/assets/img/goods-empty.png')" />
              </div>
              <div @click="handlerItemDetailClick(goods)" class="goods-data">
                <div class="now-price">¥{{ price(goods.itemSalePrice) }}</div>
              </div>
              <div @click="handlerItemDetailClick(goods)" class="goods-name">{{ goods.itemTitle }}</div>
            </div>
          </SlideWrap>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchNav from '@/components/SearchNav';
import SlideWrap from '@/components/SlideWrap';
import * as api from '@/services';
import { priceFenToYuan, throttle } from '@/helpers/utils';

export default {
  components: {
    SlideWrap,
    SearchNav
  },
  mounted() {
    this.getRecommend();
  },
  data() {
    return {
      goodsList: []
    };
  },
  methods: {
    async getRecommend() {
      const res = await api.goods.getGoodsList({
        aggregateFlag: false,
        pageNo: 1,
        pageSize: 10,
        orderType: 2
      });
      this.goodsList = res.data.itemBasicInfos || [];
    },
    price(val) {
      return priceFenToYuan(val);
    },
    handlerItemDetailClick(goods) {
      this.$router.push(`/goodsDetails/${goods.itemCode}`);
    },
    goGoodsList() {
      this.$router.push('/mallHomePage/all');
    }
  }
};
</script>

<style lang="scss" scoped>
.cpm-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
  padding-bottom: 20px;
  width: 1232px;
  margin: 0 auto;
  .shop-none-goods {
    &__title {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 24px;
      margin-top: 35px;
    }
    &__content {
      flex: 1;
      position: relative;
      min-height: 372px;
      margin-bottom: 24px;
      .none-sec {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        .none-img {
          width: 220px;
          height: 220px;
        }
        .none-txt {
          font-size: 14px;
          font-weight: 400;
          color: #8c8c8c;
        }
      }
    }
    &__intrerest {
      .goods-wrapper {
        padding-bottom: 20px;
        .goods-title {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          font-weight: 400;
          line-height: 14px;
          margin-bottom: 16px;

          .main-title {
            color: #333;
          }
          .seemore {
            color: #1e8dff;
            cursor: pointer;
          }
        }
        .goods-list::-webkit-scrollbar {
          display: none;
        }
        .goods-list {
          display: flex;
          justify-content: space-between;
          width: 100%;
          overflow-x: scroll;
          .goods-item {
            width: 219px;
            height: 297px;
            padding: 12px;
            background: rgba(255, 255, 255, 0);
            border: 1px solid #d9d9d9;
            &:not(:last-child) {
              margin-right: 24px;
            }
            cursor: pointer;
            .img-wrapper {
              position: relative;
              width: 195px;
              height: 195px;
              .img {
                width: 100%;
                height: 100%;
              }
            }
            .goods-name {
              font-size: 12px;
              font-weight: 400;
              height: 36px;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              margin-bottom: 12px;
              word-break: break-all;
              width: 195px;
              color: #262626;
              line-height: 18px;
            }
            .goods-data {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 8px;
              margin-bottom: 4px;
              .now-price {
                font-size: 18px;
                font-weight: 400;
                color: #d96900;
              }
              .orig-price {
                font-size: 12px;
                font-weight: 400;
                color: #888888;
                .num {
                  margin-left: 6px;
                  text-decoration: line-through;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
